<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Blog Categories</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a></li>
                            <li class="breadcrumb-item active">Blog Categories</li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-right col-md-6 col-12 mb-md-0 mb-2">
                <Link :href="route('admin.blog-categories.create')" class="btn btn-outline-primary float-md-right">
                    <i class="feather icon-plus icon-left"></i>
                    Add Category
                </Link>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Blog Categories</h4>
                </div>
                <div class="card-body">
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allCategories"
                    >
                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field === 'sn'">
                                {{ serialNo(props) }}
                            </span>
                            <div v-else-if="props.column.field === 'status'">
                                <span class="badge badge-glow" :class="props.row.status ? 'badge-success' : 'badge-danger'">
                                    {{ props.row.status ? 'Active' : 'Inactive' }}
                                </span>
                            </div>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <Link :href="route('admin.blog-categories.edit', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </Link>
                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../../Shared/Mixins/PaginationMixin";

export default {
    metaInfo: {title: 'Blog Categories'},
    props: ['categories'],
    layout: Layout,
    components: { Link },
    mixins: [DeleteAlert, PaginationMixin],
    data: () => ({
        allCategories: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        sortingOptions: {
            enabled: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Name', field: 'name'},
            {label: 'Slug', field: 'slug'},
            {label: 'Status', field: 'status'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
    }),
    mounted() {
        this.allCategories = this.categories.data;
        this.totalRecords = this.categories.total;
    },
    methods: {
        async paginatedData() {
            try {
                const response = await axios.get(route('admin.blog-categories.index'), {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });
                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.allCategories = response.data.data;
            } catch (e) {
                console.log(e);
            }
        },
        async deleteCategory(id) {
            this.$inertia.delete(route('admin.blog-categories.delete', id), {
                preserveScroll: true,
                onSuccess: () => this.paginatedData()
            });
        },
        async showAlert(categoryId) {
            const details = {
                title: "Are you sure you want to delete this category?",
                text: "You won't be able to revert this!",
            };
            await this.deleteAlert(details.title, details.text) ? await this.deleteCategory(categoryId) : "";
        },
    }
}
</script>
